import {initAwardsSlider} from "./awards";
import {initFeaturesSlider} from "./features";
import {initContact} from "./contact";
import {initSlider} from "./slider";
import {initCarousel} from "./carousel";
import {initLightBox} from "./lightbox";
import {initLoadMorePosts} from "./loadmore";
import {initHeader} from "./header";
import {initAccordions} from "./accordion";
import {initFilter} from "./filter";


const init = () => {
    initHeader()
    initSlider()
    initContact()
    initCarousel()
    initLightBox()
    initAwardsSlider()
    initLoadMorePosts()
    initFeaturesSlider()
    initAccordions()
    initFilter()
}

document.addEventListener('DOMContentLoaded', () => {
    init()
});
